import { render, staticRenderFns } from "./PostSection5.vue?vue&type=template&id=5ad71c86&scoped=true"
import script from "./PostSection5.vue?vue&type=script&lang=js"
export * from "./PostSection5.vue?vue&type=script&lang=js"
import style0 from "./PostSection5.vue?vue&type=style&index=0&id=5ad71c86&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad71c86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad71c86')) {
      api.createRecord('5ad71c86', component.options)
    } else {
      api.reload('5ad71c86', component.options)
    }
    module.hot.accept("./PostSection5.vue?vue&type=template&id=5ad71c86&scoped=true", function () {
      api.rerender('5ad71c86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blog/PostSection5.vue"
export default component.exports